interface CurrencyFormatOptions extends Intl.NumberFormatOptions {
  currencyPrefix?: string;
}

export const getFormattedCurrency = (
  value: number,
  intlOptions: CurrencyFormatOptions = {},
): string => {
  const { currencyPrefix = 'Rp', ...options } = intlOptions;
  return `${currencyPrefix}${value.toLocaleString(undefined, options)}`;
};
